import { createFileRoute } from '@tanstack/react-router'
import { ContractStakeholderTypePage } from '../../../components/ContractStakeholderTypePage'

export const Route = createFileRoute('/$org/contract-stakeholder-types/$contractStakeholderTypeUid')({
  component: ContractStakeholderTypeDetail,
})

function ContractStakeholderTypeDetail() {
  return <ContractStakeholderTypePage />
}